// extracted by mini-css-extract-plugin
export default {"root":"pMZR6i","title":"oXAPES","description":"WTszbg"};